import React, { useEffect, useLayoutEffect, useRef } from 'react';
import styles from './FormDropdown.module.scss';
import Lock from '../Lock/Lock';

export default function FormDropdown({
  label,
  id,
  name,
  disabled,
  multiple,
  size,
  value,
  options,
  placeholder,
  onInput,
  required,
  readOnly,
  lockStatus,
  onLockClick,
  error,
  className,
  style,
  ...rest
}) {
  const selectRef = useRef(null);

  useLayoutEffect(() => {
    // Set options and value attributes on the custom element (before paint)
    if (selectRef.current && options !== undefined) {
      let optionsToSet = options;

      if (placeholder && id) {
        // Add placeholder to the beginning of options
        const placeholderOption = {
          value: null,
          label: placeholder,
          disabled: true,
          selected: value === undefined || value === null,
        };

        if (typeof options === 'string') {
          const parsedOptions = JSON.parse(options);
          optionsToSet = JSON.stringify([placeholderOption, ...parsedOptions]);
        } else {
          optionsToSet = [placeholderOption, ...options];
        }
      }

      if (typeof optionsToSet === 'string') {
        selectRef.current.setAttribute('options', optionsToSet);
      } else {
        selectRef.current.setAttribute('options', JSON.stringify(optionsToSet));
      }

      // Set value after options using requestAnimationFrame to ensure custom element processes options first
      if (value !== undefined) {
        requestAnimationFrame(() => {
          if (selectRef.current) {
            selectRef.current.setAttribute('value', String(value));
          }
        });
      }
    }
  }, [options, placeholder, id, value]);

  return (
    <div>
      <div className={`${styles.dropdownContainer} ${style?.dropdownContainer || ''}`}>
        {label && (
          <div className={`${styles.label} ${style?.label || ''}`}>
            {label} {required && <span className={styles.required}>*</span>}
          </div>
        )}
        <div className={`${styles.value} ${style?.value || ''}`}>
          {!readOnly && (
            <nsemble-select
              ref={selectRef}
              id={id}
              name={name}
              disabled={disabled}
              multiple={multiple}
              size={size}
              onInput={onInput}
              className={className}
              {...rest}
            />
          )}
          {readOnly && <div>{value}</div>}
          <Lock
            lockStatus={lockStatus}
            onClick={onLockClick}
          />
        </div>
      </div>
      {error && <div className={`${styles.error} ${label ? styles.errorWithLabel : ''}`}>{error}</div>}
    </div>
  );
}
